import { Routes, Route } from "react-router";
import { useSelector } from "react-redux";
import { HasPermission } from "Core/security"
import { Navigate } from "react-router-dom";

import DashboardMain from "Modules/dashboard/views/main";

const DashboardView = () => {
    const user = useSelector(state => state.securityRedux.user);
    
    return (
        <>
            <Routes>
                {HasPermission(user, "pmdash") && <Route path="main" element={<DashboardMain />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default DashboardView